import { ChangeEvent, FC } from "react"

import { HeroBlock } from "../types/types"

type HeroBlockEditorProps = {
  block: HeroBlock
  onChange: (patch: Partial<HeroBlock>) => void
}

export const HeroBlockEditor: FC<HeroBlockEditorProps> = ({ block, onChange }) => {
  const handleInput = (key: keyof HeroBlock["props"]) => (e: ChangeEvent<HTMLInputElement>) => {
    onChange({
      props: {
        ...block.props,
        [key]: e.target.value
      }
    })
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
      <div>
        <label className="label block mb-1 text-xs">Headline *</label>
        <input
          className="input input-bordered w-full"
          value={block.props.headline}
          onChange={handleInput("headline")}
          placeholder="Headline placeholder"
        />
      </div>

      <div>
        <label className="label block mb-1 text-xs">Subheadline</label>
        <input
          className="input input-bordered w-full"
          value={block.props.subheadline ?? ""}
          onChange={handleInput("subheadline")}
          placeholder="Subheadline placeholder"
        />
      </div>

      <div>
        <label className="label block mb-1 text-xs">Background Image</label>
        <input
          className="input input-bordered w-full"
          value={block.props.backgroundImage ?? ""}
          onChange={handleInput("backgroundImage")}
          placeholder="Insert a url"
        />
      </div>
    </div>
  )
}
